import {lazy, Suspense} from 'react';
import {createBrowserRouter, createRoutesFromElements, Outlet, Route} from 'react-router-dom';
import RootLayout from 'src/routes/layouts/root/RootLayout';
import ErrorPage from "./ErrorPage";
import PublicLayout from "./layouts/public/PublicLayout";
import Policy from "./public/policy";

export const IndexPage = lazy(() => import('src/routes/public/Home'));
export const AboutPage = lazy(() => import('src/routes/public/About'));
export const ClickerCfgPage = lazy(() => import('src/routes/ClickerCfg'));
export const SystemCfgPage = lazy(() => import('src/routes/SystemCfg'));
export const NavigationCfgPage = lazy(() => import('src/routes/NavigationCfg'));
export const ScrollerCfgPage = lazy(() => import('src/routes/ScrollerCfg'));
export const RulesCfgPage = lazy(() => import('src/routes/RulesCfg'));
export const NameConfigPage = lazy(() => import('src/routes/NameConfig'));
export const WitAuditPage = lazy(() => import('src/routes/WitAudit'));
export const WitThresholdsPage = lazy(() => import('src/routes/WitThresholds'));
export const WitTrainingQueuePage = lazy(() => import('src/routes/WitTrainingQueue'));
export const StatisticsPage = lazy(() => import('src/routes/Statistics'));
export const RoleBuilderPage = lazy(() => import('src/routes/RoleBuilder'));
export const ProfilePage = lazy(() => import('src/routes/Profile'));
export const LinkedInAccPage = lazy(() => import('src/routes/LinkedInAcc'));

export const router = createBrowserRouter(
  createRoutesFromElements([
    <Route
      path="/"
      element={(
        <RootLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </RootLayout>
      )}
      errorElement={<ErrorPage />}
    >
      <Route errorElement={<ErrorPage />}>
        <Route path="cfg-config" element={<ClickerCfgPage />} />
        <Route path="system-config" element={<SystemCfgPage />} />
        <Route path="navigation-config" element={<NavigationCfgPage />} />
        <Route path="scroller-config" element={<ScrollerCfgPage />} />
        <Route path="rules-config" element={<RulesCfgPage />} />
        <Route path="name-config" element={<NameConfigPage />} />
        <Route path="wit-audit" element={<WitAuditPage />} />
        <Route path="wit-thresholds" element={<WitThresholdsPage />} />
        <Route path="wit-training-queue" element={<WitTrainingQueuePage />} />
        <Route path="statistics" element={<StatisticsPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="linkedIn-acc" element={<LinkedInAccPage />} />
      </Route>
    </Route>,
    <Route
      path="/"
      element={(
        <PublicLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </PublicLayout>
      )}
      errorElement={<ErrorPage />}
    >
      <Route errorElement={<ErrorPage />}>
        <Route index element={<IndexPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="private-policy" element={<Policy />} />
      </Route>
    </Route>,
  ])
);
